import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TrainingAvailability } from '@app/core/constants/training-status.constants';

@Component({
  selector: 'app-training-name-with-state',
  templateUrl: './training-name-with-state.component.html',
  styleUrls: ['./training-name-with-state.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,

  standalone: false,
})
export class TrainingNameWithStateComponent {
  @Input() text = '';
  @Input() url = '';
  @Input() state = TrainingAvailability.ACTIVE;

  TrainingAvailability = TrainingAvailability;

  constructor() {}
}
